import React from 'react';
import gql from 'graphql-tag';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getFlipper } from '../../src/web/store/modules/company';
import { getFonts } from '../../src/web/store/modules/site';
import { getUserAuthProfile } from '../../src/web/store/modules/user';
import { FLIPPER_FULL_STORY } from '../../constants/flippers';
import useQuery from '../../modules/react/hooks/useQuery';
import generateThemeClasses from '../../src/web/middleware/renderer/generateThemeClasses';
import Component from '../components/App';

const GET_CURRENT_SITE_SOFTWARE_PROVIDERS = gql`
  query GetCurrentSiteSoftwareProviders {
    currentSite {
      id
      softwareProviders
    }
  }
`;

const propTypes = {
  fonts: PropTypes.object.isRequired,
  fullStoryEnabled: PropTypes.bool.isRequired,
  themeClasses: PropTypes.string,
  user: PropTypes.object.isRequired,
};

const defaultProps = { themeClasses: '' };

const App = ({
  fonts,
  fullStoryEnabled,
  themeClasses,
  user,
  ...rest
}) => {
  const { data, loading, error } = useQuery(GET_CURRENT_SITE_SOFTWARE_PROVIDERS);

  // We don't want to render <App /> until we have gotten the site's software
  // providers back. If we do, Echo notifications may not be filtered properly.
  if (!data || loading) {
    return null;
  }

  const softwareProviders = error ? [] : data.currentSite.softwareProviders;

  return (
    <Component
      {...rest}
      fonts={fonts}
      fullStoryEnabled={fullStoryEnabled}
      softwareProviders={softwareProviders}
      themeClasses={themeClasses}
      user={user}
    />
  );
};

App.propTypes = propTypes;
App.defaultProps = defaultProps;

const mapStateToProps = state => ({
  fullStoryEnabled: getFlipper(state, FLIPPER_FULL_STORY),
  user: getUserAuthProfile(state) || {},
  fonts: getFonts(state) || {},
  themeClasses: generateThemeClasses(state) || undefined,
});

const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(App);
